import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { streem } from 'streem-sdk-protobuf';
import { Streemshot, StreemshotDetection } from '@streem/sdk-core';

import { dedupeDetections, useObservable } from '@streem/sdk-react';
import { useDetailSession } from './detail_session_hooks';

interface useModelSerialDetectionReturnValues {
    streemshots: Streemshot[];
    dedupedModelSerial: StreemshotDetection[];
    handleModelSerialClick: (
        detection: StreemshotDetection,
        streemshotToDisplay?: Streemshot,
    ) => void;
}

export const useModelSerialDetection = (): useModelSerialDetectionReturnValues => {
    const history = useHistory();
    const detailSession = useDetailSession();
    const [streemshots = []] = useObservable(detailSession.streemshots.responses);
    const [modelSerial = []] = useObservable(
        detailSession.detection.getDetections({
            types: [
                streem.api.Detection.Type.DETECTION_TYPE_MODEL,
                streem.api.Detection.Type.DETECTION_TYPE_SERIAL,
            ],
        }),
    );

    const dedupedModelSerial = useMemo(() => dedupeDetections(modelSerial), [modelSerial]);

    const handleModelSerialClick = (
        detection: StreemshotDetection,
        streemshotToDisplay?: Streemshot,
    ) => {
        const url = `${location.pathname}/artifact/${
            streemshotToDisplay?.id || detection.streemshotSid
        }`;
        history.push(url);
    };

    return {
        streemshots,
        dedupedModelSerial,
        handleModelSerialClick,
    };
};
